// local with prod backend
// export const BASE_URL = "https://backend.webooth.temporaldomain.com";
// export const USE_JWT = true;

// local
// export const BASE_URL = "http://localhost:8001";
// export const USE_JWT = true;

// outter world
// export const BASE_URL = "https://working-rapidly-civet.ngrok-free.app";
// export const USE_JWT = true;

// local with google
// export const BASE_URL = "http://localhost:8001";
// export const USE_JWT = false;

// prod
export const BASE_URL = "https://backend.webooth.temporaldomain.com";
export const USE_JWT = false;
